import { render, staticRenderFns } from "./stackColumnVertical.vue?vue&type=template&id=55c91faf&scoped=true"
import script from "./stackColumnVertical.vue?vue&type=script&lang=js"
export * from "./stackColumnVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c91faf",
  null
  
)

export default component.exports